var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:({ height: _vm.vm.isMobile && _vm.height }),attrs:{"id":"kv-banner"}},[_c('div',{ref:"animationPic",staticClass:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }